import { SVGProps, Ref, forwardRef } from 'react'
const SvgCoffin = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.42 23.25H8.76a1.5 1.5 0 0 1-1.455-1.136L3.974 8.788a1.5 1.5 0 0 1 .114-1.034l3.087-6.175A1.5 1.5 0 0 1 8.517.75h7.146A1.5 1.5 0 0 1 17 1.579l3.088 6.175c.16.32.2.687.112 1.034l-3.326 13.326a1.5 1.5 0 0 1-1.455 1.136v0ZM12.09 5.25V16.5M9.09 8.25h6"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCoffin)
export default ForwardRef
